// Grouped client for ProductCatalog operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Estimate } from '../models/Estimate';
import { RoomSelection } from '../models/RoomSelection';
import { CreateFromSelectionsRequest } from '../models/CreateFromSelectionsRequest';
import { FindRoomSelectionRequest } from '../models/FindRoomSelectionRequest';
import { EstimateSerializer } from '../serializers/EstimateSerializer';
import { RoomSelectionSerializer } from '../serializers/RoomSelectionSerializer';
import { CreateFromSelectionsRequestSerializer } from '../serializers/CreateFromSelectionsRequestSerializer';
import { FindRoomSelectionRequestSerializer } from '../serializers/FindRoomSelectionRequestSerializer';

/**
 * HTTP client for ProductCatalog operations
 *
 * Client for ProductCatalog operations
 */
export class ProductCatalogClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  /**
   * Create Estimate from Room Selections
   * Create From Selections 
   * @param request Create Estimate from Room Selections - Request Body 
   * @param options Optional request options (additional headers, etc.)
   */
  async createFromSelections(request?: CreateFromSelectionsRequest | null, options?: { headers?: Record<string, string> }): Promise<Estimate> {
    const path = '/productcatalog/api/Estimate/RoomSelections';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateFromSelectionsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return EstimateSerializer.fromObject(data);
  }

  /**
   * Find Room Selection and auto-create when possible
   * FindRoomSelection
   * @param request Request body to find Room Selection
   * @param options Optional request options (additional headers, etc.)
   */
  async findRoomSelection(request?: FindRoomSelectionRequest | null, options?: { headers?: Record<string, string> }): Promise<RoomSelection> {
    const path = '/productcatalog/api/RoomSelection/Find';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PUT',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FindRoomSelectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return RoomSelectionSerializer.fromObject(data);
  }

}
